import { Done, DoNotDisturb } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

export default function TrueFalseImage({
  value,
  iconColor,
  notCentered,
  onClick,
  toolTip,
}) {
  const loadComponent = () => {
    if (toolTip) {
      return (
        <Tooltip title={toolTip} placement="top">
          {getComponentImage()}
        </Tooltip>
      );
    }

    return getComponentImage();
  };

  const getComponentImage = () => {
    return value ? (
      <Done className="text-2xl" style={{ color: iconColor ?? "green" }} />
    ) : (
      <DoNotDisturb className="text-lg" style={{ color: iconColor ?? "red" }} />
    );
  };

  return (
    <div
      style={{ cursor: onClick ? "pointer" : "default" }}
      className={!notCentered ? "content_centered_horizontally" : ""}
      onClick={onClick}
    >
      {loadComponent()}
    </div>
  );
}
